import React, { useCallback, useEffect, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import FigoLottie from '../common/FigoLottie';
import { Iframe } from '../common/iframe/Iframe';

import { useOnPostMessage, useWebviewMultibrand } from '../../hooks';
import { POST_MESSAGE_TYPES, WEB_VIEW_TYPES } from '../../constants';
import { HOME } from '../navigation/routes.constants';
import { refreshPolicies } from '../../actions';

import './AddPetScreenIFrame.css';

const AddPetScreenIFrame = () => {
  const { t } = useTranslation('insurance');
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const { getWebView, isLoading, url } = useWebviewMultibrand();

  const selectedPolicy = useMemo(() => {
    if (!location.state) {
      return {};
    }

    return location.state.selectedPolicy;
  }, [location.state]);

  const selectedPet = useMemo(() => {
    if (!location.state) {
      return {};
    }

    return location.state.selectedPet;
  }, [location.state]);

  useEffect(() => {
    if (!selectedPolicy) {
      return;
    }

    const request = {
      companyId: selectedPolicy.MarketChannelId,
      coveragePeriodId: selectedPolicy.CoveragePeriodId,
      policyId: selectedPolicy.Id,
      policyNumber: selectedPolicy.PolicyDisplayNumber,
      webViewType: WEB_VIEW_TYPES.addingNewPetToPolicy,
    };

    if (selectedPet) {
      request.petId = selectedPet.PetId;
    }

    getWebView(request);
  }, [selectedPolicy, selectedPet]);

  const onMessage = useCallback(({ data }) => {
    const closePage = data === POST_MESSAGE_TYPES.CLOSE_PAGE;
    const goToDashboard = data === POST_MESSAGE_TYPES.NEW_PET_ADDED;

    if (closePage) {
      history.go(-2);
    } else if (goToDashboard) {
      // refreshes the policie and pet list :ice:
      dispatch(refreshPolicies());
      history.replace(HOME);
    }
  }, [history, dispatch]);

  useOnPostMessage({ onMessage, url });

  if (isLoading || !url) {
    return <FigoLottie />;
  }

  return (
    <div className="Add-pet-iframe-container">
      <div className="Add-pet-iframe-title-page-container">
        <h1>{t('addOrcaPetIFrame.title')}</h1>

        <p>{t('addOrcaPetIFrame.description')}</p>
      </div>

      <Iframe
        allowFullScreen
        src={url}
        title={t('addOrcaPetIFrame.title')}
      />
    </div>
  );
};

export { AddPetScreenIFrame };
